module.exports = global["Raphael"] = require("-!/builds/10xcrew/activationboxx/node_modules/babel-loader/lib/index.js??ref--4!./raphael.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Raphael!./node_modules/porto-admin/HTML/vendor/raphael/raphael.js-exposed
// module id = 58
// module chunks = 0